const DEFAULT_API_BASE_URL = "http://localhost:3000";
const DEFAULT_IMAGE_UPLOAD_PATH = "dev/image";

const trimSlashes = (value: string) => value.replace(/^\/+|\/+$/g, "");

export const getApiBaseUrl = () => {
  const configuredBaseUrl = process.env.API_ENDPOINT?.trim();

  return configuredBaseUrl ? configuredBaseUrl : DEFAULT_API_BASE_URL;
};

export const getImageUploadPath = () => {
  const configuredPath = process.env.IMAGE_UPLOAD_PATH?.trim();

  return trimSlashes(configuredPath || DEFAULT_IMAGE_UPLOAD_PATH);
};

export const getSignedUploadPath = () => {
  const configuredPath = process.env.SIGNED_UPLOAD_PATH?.trim();

  if (configuredPath) {
    return trimSlashes(configuredPath);
  }

  const imageUploadPath = getImageUploadPath();

  if (imageUploadPath.endsWith("/image")) {
    return `${imageUploadPath.slice(0, -"/image".length)}/signed-url`;
  }

  if (imageUploadPath === "image") {
    return "signed-url";
  }

  return imageUploadPath;
};
